// extracted by mini-css-extract-plugin
module.exports = {"sizeItem":"SizeItem_sizeItem__v0Bm2","selectable":"SizeItem_selectable__ETiIg"};